import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { checkEnumValue } from '@/helpers/checkEnumValue'

import { DEFAULT_INSIGHTS_TIMEFRAME, InsightsTimeframe, timeframeToPeriodPreset } from './insightsTimeframe'

export const useRouterQueryInsightsTimeframe = () => {
  const route = useRoute()
  const router = useRouter()

  const timeframe = computed<InsightsTimeframe>(() => checkEnumValue(route.query.timeframe, InsightsTimeframe, DEFAULT_INSIGHTS_TIMEFRAME))
  const periodPreset = computed(() => timeframeToPeriodPreset(timeframe.value))

  function setTimeframe(value: InsightsTimeframe) {
    router.push({
      query: {
        ...route.query,
        timeframe: value !== DEFAULT_INSIGHTS_TIMEFRAME ? value : undefined,
      },
    })
  }

  return { timeframe, periodPreset, setTimeframe }
}
